/* eslint-disable camelcase */
import { z } from 'zod'

import { RegistrationFormErrors } from '../types/errors'

export const formSchema = z
	.object({
		email: z
			.string({ required_error: RegistrationFormErrors.EMAIL_REQUIRED })
			.min(1, RegistrationFormErrors.EMAIL_REQUIRED)
			.email(RegistrationFormErrors.EMAIL_INVALID),
		password: z
			.string({ required_error: RegistrationFormErrors.PASSWORD_REQUIRED })
			.min(6, RegistrationFormErrors.PASSWORD_MIN_LENGTH),
		confirmPassword: z.string({
			required_error: RegistrationFormErrors.PASSWORD_REQUIRED
		})
	})
	.refine(obj => obj.confirmPassword === obj.password, {
		message: RegistrationFormErrors.PASSWORD_MATCHES,
		path: ['confirmPassword']
	})

export type FieldValues = z.infer<typeof formSchema>
